

export class TyreModelUpdateInput implements ITyreModelUpdateInput {
    /** The auto-generated id of the tyre model master */
    tyreModelId!: number;
    /** The tyre model name with 255 character limit */
    tyreModelName!: string;

    constructor(data?: ITyreModelUpdateInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tyreModelId = _data["tyreModelId"];
            this.tyreModelName = _data["tyreModelName"];
        }
    }

    static fromJS(data: any): TyreModelUpdateInput {
        data = typeof data === 'object' ? data : {};
        let result = new TyreModelUpdateInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tyreModelId"] = this.tyreModelId;
        data["tyreModelName"] = this.tyreModelName;
        return data; 
    }
}

export interface ITyreModelUpdateInput {
    /** The auto-generated id of the tyre model master */
    tyreModelId: number;
    /** The tyre model name with 255 character limit */
    tyreModelName: string;
}

